// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"298":"face8c90","794":"f8f6c92e","971":"7d22ca14"}[chunkId] + ".js";
};